import { formatRelativeTime, escapeHtml } from '../utils/index.js';

class NoteList extends HTMLElement {
  _notes = [];
  _view = 'desktop';
  _boundHandlers = new Map();

  static observedAttributes = ['view'];

  constructor() {
    super();
  }

  set notes(value) {
    this._notes = value;
    this.render();
  }

  get notes() {
    return this._notes;
  }

  get view() {
    return this.getAttribute('view') || 'desktop';
  }

  connectedCallback() {
    this.render();
  }

  disconnectedCallback() {
    this._removeEventListeners();
  }

  attributeChangedCallback() {
    this.render();
  }

  setSelectedNote(noteId) {
    const items = this.querySelectorAll('note-item');
    items.forEach((item) => {
      item.selected = item.note?.id === noteId;
    });
  }

  _removeEventListeners() {
    this._boundHandlers.forEach((handler, element) => {
      element.removeEventListener('click', handler);
    });
    this._boundHandlers.clear();
  }

  render() {
    this._removeEventListeners();

    if (this._notes.length === 0) {
      this.innerHTML = `
        <div class="note-list-empty" role="status" aria-label="No notes available">
          <h3 class="note-list-empty-title">No Notes Yet</h3>
          <p class="note-list-empty-text">Create your first note to get started</p>
        </div>
      `;
      return;
    }

    const isMobile = this.view === 'mobile';

    if (isMobile) {
      // Mobile card layout
      let cardsHtml = '';
      this._notes.forEach((note, index) => {
        cardsHtml += `
          <article class="note-list-mobile-card" data-index="${index}" role="listitem" tabindex="0">
            <div class="note-list-mobile-card-header">
              <h3 class="note-list-mobile-card-title">${escapeHtml(note.title)}</h3>
              <span class="note-list-mobile-card-date">${formatRelativeTime(note.createdAt)}</span>
            </div>
            <p class="note-list-mobile-card-body">${escapeHtml(note.body)}</p>
          </article>
        `;
      });

      this.innerHTML = `
        <div class="note-list-grid mobile" role="list">
          ${cardsHtml}
        </div>
      `;

      // Attach click handlers to mobile cards
      const cards = this.querySelectorAll('.note-list-mobile-card');
      cards.forEach((card) => {
        const index = parseInt(card.dataset.index, 10);
        const note = this._notes[index];
        const clickHandler = () => {
          this.dispatchEvent(
            new CustomEvent('note-selected', {
              detail: { note },
              bubbles: true,
            })
          );
        };
        card.addEventListener('click', clickHandler);
        this._boundHandlers.set(card, clickHandler);
      });
    } else {
      // Desktop list layout with note-item
      this.innerHTML = `<div class="note-list-items" role="list"></div>`;
      const container = this.querySelector('.note-list-items');

      this._notes.forEach((note) => {
        const noteItem = document.createElement('note-item');
        noteItem.note = note;
        noteItem.setAttribute('role', 'listitem');
        container.appendChild(noteItem);
      });
    }
  }
}

customElements.define('note-list', NoteList);
